import { useQuery } from "@apollo/client/react";
import { GetAllCustomers } from "./customer.gql";

export default function useGetCustomers() {
  const { data, error, loading, refetch } = useQuery(GetAllCustomers);

  return { data, error, loading, refetch };
}
